import ComplementoConceptoHidroYPetro from './ComplementoConceptoHidroYPetro';
import ComplementoConceptoInstEducativas from './ComplementoConceptoInstEducativas';
import ComplementoConceptoVentaVehiculos from './ComplementoConceptoVentaVehiculos';

const ComplementoConceptoList = {
  instEducativas: ComplementoConceptoInstEducativas,
  VentaVehiculos: ComplementoConceptoVentaVehiculos,
  HidroYPetro: ComplementoConceptoHidroYPetro,
}

export default ComplementoConceptoList;